import { Injectable } from '@angular/core';
import { DataResponseHttp } from '../../../http-models/data-response.http';
import { HospitalHttp } from '../../../http-models/systems/hospital/hospital.http';
import { DataResponseModel } from '../../../models/apis/data-response.model';
import { HospitalModel } from '../../../models/apis/system/hospital/hospital.model';
import { BaseMapper } from '../../base.mapper';


@Injectable({
    providedIn: 'root',
})
export class GetHospitalByIdMapper implements
    BaseMapper<DataResponseModel<HospitalModel>, DataResponseHttp<HospitalHttp>> {
    convertFrom(http: DataResponseHttp<HospitalHttp>): DataResponseModel<HospitalModel> {
        let response = {
            isError: http.isError,
            errors: http.errors
        } as DataResponseModel<HospitalModel>;
        if (http.isError != true && http.data) {
            response.data = {
                id: http.data.id,
                name: http.data.name,
                code: http.data.code,
                address1: http.data.address1 ?? '',
                address2: http.data.address2 ?? '',
                contactNumber: http.data.contactNumber ?? '',
                halalPrinterName: http.data.halalPrinterName ?? '',
                nonHalalPrinterName: http.data.nonHalalPrinterName ?? '',
                pictureCollapsedUrl: http.data.pictureCollapsedUrl ?? '',
                pictureExpandedUrl: http.data.pictureExpandedUrl ?? '',
                isActive: http.data.isActive,
                createdBy: http.data.createdBy,
                createdDateUtc: new Date(http.data.createdDateUtc),
                updatedBy: http.data.updatedBy,
                updatedDateUtc: new Date(http.data.updatedDateUtc),
                useMealUpgradeOption: http.data.useMealUpgradeOption,
                mealUpgradeOption: http.data.mealUpgradeOption,
                autoOrderTea: http.data.autoOrderTea,
                autoOrderTeaFollowPrevMeal: http.data.autoOrderTeaFollowPrevMeal,
                autoOrderMealClass: http.data.autoOrderMealClass,
                autoOrderForPlanned: http.data.autoOrderForPlanned,
                autoOrderMail: http.data.autoOrderMail,
                pbtBehaviorOption: http.data.pbtBehaviorOption,
                navbarBackgroundColor: http.data.navbarBackgroundColor ?? "#b32b23",
                navbarForegroundColor: http.data.navbarForegroundColor ?? "#ffffff",
                pbtShowGuestMealOrderOption: http.data.pbtShowGuestMealOrderOption,
                showQrCodeinMealSlip: http.data.showQrCodeinMealSlip,
                enableDns153: http.data.enableDns153,
                companionMealEnableByAge: http.data.companionMealEnableByAge ?? false,
                companionMealEnableByMealClass: http.data.companionMealEnableByMealClass ?? false,
                companionMealEnableByWard: http.data.companionMealEnableByWard ?? false
            };
        }
        return response;
    }

}
